var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeddingExperts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.473,
    height: 61.5,
    viewBox: "0 0 44.473 61.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#dfeef7;}.b{fill:#fd9;}.c{fill:none;stroke:#1f3951;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}.d{fill:#f9f7f6;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-997.656 -94.39)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1039.129,166.764H998.406V152.086a10.707,10.707,0,0,1,10.707-10.707h19.309a10.707,10.707,0,0,1,10.707,10.707v14.678Z",
    transform: "translate(3 -14.624)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1031.716,106.707a6.831,6.831,0,0,0-1.576-4.024c-1.993-2.5-6.778-5.119-13.037-2.145-5.74,2.728-3.952,9.118-3.952,9.118,9.04,2.613,11.625-2.876,14.279-2l.792.3",
    transform: "translate(-3.64 -1.024)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1029.556,125.576c-1.6,3.021-3.989,5.061-6.655,5.061-3.619,0-6.723-3.761-8.05-8.628",
    transform: "translate(-4.134 -6.755)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1031.716,106.707a6.831,6.831,0,0,0-1.576-4.024c-1.993-2.5-6.778-5.119-13.037-2.145-5.74,2.728-3.952,9.118-3.952,9.118,9.04,2.613,11.625-2.876,14.279-2l.792.3",
    transform: "translate(-3.64 -1.024)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1010,142.379l8.012,11.363a4.492,4.492,0,0,0,7.343,0l8.22-11.826",
    transform: "translate(-2.915 -11.875)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1010,142.379l8.012,11.363a4.492,4.492,0,0,0,7.343,0l6.008-8.525",
    transform: "translate(-2.915 -11.875)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1039.129,166.764H998.406V152.086a10.707,10.707,0,0,1,10.707-10.707h19.309a10.707,10.707,0,0,1,10.707,10.707v14.678Z",
    transform: "translate(0 -11.624)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1026.4,144.964l.816-3.585h-4.861l.69,3.585",
    transform: "translate(-6.021 -11.624)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1027.855,154.9l-1.622-8.337h-3.519l-1.623,8.337",
    transform: "translate(-5.702 -12.927)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1012.876 123.073)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 0.57,
    y2: 2.989,
    transform: "translate(11.217 3.024)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    y1: 5.964,
    x2: 0.92
  })), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 7.018,
    height: 3.504,
    transform: "translate(1027.954 142.448)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2.427,0H3.743a0,0,0,0,1,0,0V6.326a0,0,0,0,1,0,0H2.427A2.427,2.427,0,0,1,0,3.9V2.427A2.427,2.427,0,0,1,2.427,0Z",
    transform: "matrix(0.983, -0.184, 0.184, 0.983, 1005.794, 109.655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2.427,0H3.743a0,0,0,0,1,0,0V6.326a0,0,0,0,1,0,0H2.427A2.427,2.427,0,0,1,0,3.9V2.427A2.427,2.427,0,0,1,2.427,0Z",
    transform: "matrix(-0.983, -0.184, 0.184, -0.983, 1030.608, 115.873)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1009.118,109.344l-.305-2.462c-.773-6.237,5.049-11.742,11.334-11.742h2.246c6.107,0,11.744,5.211,11.253,11.3l-.211,2.614",
    transform: "translate(-2.599)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1037.562,123.749l-.171.7a1.507,1.507,0,0,1-1.464,1.15h-5.367",
    transform: "translate(-8.083 -7.192)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeddingExperts);
export default __webpack_public_path__ + "static/media/bedding-experts.7f0d20ee772395587ae548fb52f9f71b.svg";
export { ForwardRef as ReactComponent };